import { render, staticRenderFns } from "./SectionSix.vue?vue&type=template&id=bf8e0028"
import script from "./SectionSix.vue?vue&type=script&lang=js"
export * from "./SectionSix.vue?vue&type=script&lang=js"
import style0 from "./SectionSix.vue?vue&type=style&index=0&id=bf8e0028&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports